export default (props = {}) => <svg viewBox="0 0 10 5" xmlns="http://www.w3.org/2000/svg"{...props}><path d="m0 5 4-4q1-1 2 0l4 4Z" fill="currentColor"/></svg>